import { render, staticRenderFns } from "./EmployeeBadgeCounter.vue?vue&type=template&id=24ceb5cd&scoped=true"
import script from "./EmployeeBadgeCounter.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeBadgeCounter.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EmployeeBadgeCounter.vue?vue&type=style&index=0&id=24ceb5cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ceb5cd",
  null
  
)

export default component.exports